// @flow
import { StyleSheet } from 'react-native';
import theme from '../../theme-config';

export function getStyles() {
  return StyleSheet.create({
    text: {
      fontWeight: '600',
      fontSize: 14,
      color: theme.signUpTextColor,
    },
    neutralText: {
      color: theme.gray.normal,
    },
    container: {
      flexDirection: 'row',
      justifyContent: 'flex-start',
      backgroundColor: 'transparent',
    },
    legend: {
      fontWeight: '300',
      fontSize: 13,
      color: theme.signUpTextColor,
    },
    neutralLegend: {
      color: theme.gray.normal,
    },
    textContainer: {
      marginLeft: 16,
      backgroundColor: 'transparent',
    },
  });
}
